var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { React, jsx, css, polished, esri, classNames, injectIntl, DataSourceManager, dataSourceUtils, JimuFieldType, ReactRedux, DataSourceTypes, DataSourceStatus, EMPTY_OPTION_VALUE, getAppStore, QueryScope, lodash, ClauseOperator, ClauseLogic, focusElementInKeyboardMode, dateUtils } from 'jimu-core';
import { LoadingType } from './types';
import { TextInput } from './text-input';
import { Label } from './label';
import { Button } from './button';
import { Checkbox } from './switch';
import { Dropdown, DropdownButton, DropdownMenu, DropdownItem } from './dropdown';
import defaultMessages from '../translations/default';
import { Loading } from './loading';
import { QueryScopeContext } from './query-scope-context';
import { withStyles } from 'jimu-theme';
import { SearchOutlined } from 'jimu-icons/outlined/editor/search';
import { CheckOutlined } from 'jimu-icons/outlined/application/check';
import { InfoOutlined } from 'jimu-icons/outlined/suggested/info';
import { MenuOutlined } from 'jimu-icons/outlined/editor/menu';
import { ShowSelectionOutlined } from 'jimu-icons/outlined/editor/show-selection';
import { ShowSelectionRtlOutlined } from 'jimu-icons/outlined/editor/show-selection--rtl';
import { TrashCheckOutlined } from 'jimu-icons/outlined/editor/trash-check';
const LOCAL_DS_PREFIX = 'ADVANCED_SELECT';
const MIN_COUNT_FOR_SCROLLING = 8; // 7 can trigger scroll bar
const shiftOptions = {
    crossAxis: true
};
const numericFieldLength = {
    esriFieldTypeOID: 32,
    esriFieldTypeSmallInteger: 16,
    esriFieldTypeInteger: 32,
    esriFieldTypeSingle: 128,
    esriFieldTypeDouble: 1024
};
export class _AdvancedSelectInner extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isDsInfoChanged = (prevProps) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const { isMultiple, dataSourceInfo, dataSourceBelongInfo } = this.props;
            const dsInfoChanged = dataSourceInfo !== prevProps.dataSourceInfo || dataSourceBelongInfo !== prevProps.dataSourceBelongInfo;
            if (!dsInfoChanged ||
                (((_a = prevProps.dataSourceInfo) === null || _a === void 0 ? void 0 : _a.status) === DataSourceStatus.Loaded && (dataSourceInfo === null || dataSourceInfo === void 0 ? void 0 : dataSourceInfo.status) === DataSourceStatus.Loading) || // loaded to loading when values are changed.
                (((_b = prevProps.dataSourceInfo) === null || _b === void 0 ? void 0 : _b.status) === DataSourceStatus.Loading && (dataSourceInfo === null || dataSourceInfo === void 0 ? void 0 : dataSourceInfo.status) === DataSourceStatus.Loaded) || // loading to loaded after the above status.
                (((_c = prevProps.dataSourceBelongInfo) === null || _c === void 0 ? void 0 : _c.status) === DataSourceStatus.Loaded && (dataSourceBelongInfo === null || dataSourceBelongInfo === void 0 ? void 0 : dataSourceBelongInfo.status) === DataSourceStatus.Loading) ||
                (((_d = prevProps.dataSourceBelongInfo) === null || _d === void 0 ? void 0 : _d.status) === DataSourceStatus.Loading && (dataSourceBelongInfo === null || dataSourceBelongInfo === void 0 ? void 0 : dataSourceBelongInfo.status) === DataSourceStatus.Loaded)) {
                return false;
            }
            // loaded & loaded, sql is changed by selecting values.
            const currentWidgetQueriesChanged = ((_e = dataSourceInfo === null || dataSourceInfo === void 0 ? void 0 : dataSourceInfo.widgetQueries) === null || _e === void 0 ? void 0 : _e[this.context.widgetId]) !== ((_g = (_f = prevProps.dataSourceInfo) === null || _f === void 0 ? void 0 : _f.widgetQueries) === null || _g === void 0 ? void 0 : _g[this.context.widgetId]);
            if (currentWidgetQueriesChanged) {
                if (!isMultiple || this.state.isOpen) { // single, multiple & open
                    return false;
                }
            }
            return dsInfoChanged;
        };
        this.i18nMessage = (id, values) => {
            return this.props.intl.formatMessage({ id: id, defaultMessage: defaultMessages[id] }, values);
        };
        this.showCheckAll = (staticValues) => {
            const { hideSearchInput = false, hideCheckAll = true, hideBottomTools = false, isMultiple } = this.props;
            return !hideCheckAll && isMultiple && hideSearchInput && hideBottomTools && (staticValues === null || staticValues === void 0 ? void 0 : staticValues.length) > 1;
        };
        // get checkAll states
        this.getCheckAllStates = (currentList, selectedValues) => {
            const checkAllChecked = (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) === currentList.length;
            const checkAllIndeterminate = (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) < currentList.length && (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0;
            return {
                checkAllChecked,
                checkAllIndeterminate
            };
        };
        this.getPageSize = (includedRealStaticValues) => {
            var _a, _b, _c;
            return (includedRealStaticValues === null || includedRealStaticValues === void 0 ? void 0 : includedRealStaticValues.length) > 0
                ? includedRealStaticValues.length
                : Math.max((_c = (_b = (_a = this.props.dataSource) === null || _a === void 0 ? void 0 : _a.getDataViewConfig()) === null || _b === void 0 ? void 0 : _b.pageSize) !== null && _c !== void 0 ? _c : 0, 20);
        };
        this.createDataSources = () => {
            var _a;
            if (this.dsManager) {
                if ((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.id) {
                    this.destroyDataSources();
                }
                this.dataSource = this.dsManager.createLocalDataSource(this.props.dataSource, this.localDsRandomId);
                this.dataSourceForSearch = this.dsManager.createLocalDataSource(this.props.dataSource, this.localDsRandomId + '-search');
            }
        };
        this.destroyDataSources = () => {
            if (this.dsManager) {
                this.dsManager.destroyDataSource(this.dataSource.id);
                this.dsManager.destroyDataSource(this.dataSourceForSearch.id);
            }
        };
        this.isStaticValuesChanged = (staticValues, prevStaticValues) => {
            let isEqual = false;
            if (!staticValues && !prevStaticValues) {
                isEqual = true;
            }
            else if (staticValues && prevStaticValues && staticValues.length === prevStaticValues.length) {
                isEqual = !staticValues.some((v, i) => v.value !== prevStaticValues[i].value || v.label !== prevStaticValues[i].label || v.disabled !== prevStaticValues[i].disabled);
            }
            return !isEqual;
        };
        /**
         * get real static values from staticValues, or codedValues from layer.
         */
        this.getRealStaticValues = () => {
            const { dataSource, field, staticValues, useCodedValues = true, sortValuesByLabel = true } = this.props;
            const valuePairs = staticValues ||
                (useCodedValues ? dataSource === null || dataSource === void 0 ? void 0 : dataSource.getFieldCodedValueList(field === null || field === void 0 ? void 0 : field.jimuName) : null);
            return sortValuesByLabel ? this.sortValuePairs(valuePairs) : valuePairs;
        };
        /**
         * Sort value pairs by label.
         */
        this.sortValuePairs = (valuePairs) => {
            if (!valuePairs) {
                return null;
            }
            // Create a copy of the valuePairs array before sorting.
            return [...valuePairs].sort((v1, v2) => { var _a; return (_a = v1.label) === null || _a === void 0 ? void 0 : _a.localeCompare(v2.label, this.props.intl.locale, { numeric: true, sensitivity: 'base' }); });
        };
        this.showOutputWarningInBuilder = () => {
            return this.showOutputWarning() && this.context.scope !== QueryScope.InRuntimeView;
        };
        this.showOutputWarning = () => {
            var _a;
            return !this.props.staticValues && ((_a = this.props.dataSource.getDataSourceJson()) === null || _a === void 0 ? void 0 : _a.isOutputFromWidget);
        };
        this.updateList = (page_1, ...args_1) => __awaiter(this, [page_1, ...args_1], void 0, function* (page, queryCount = false, autoTriggeredByFirstPage = false) {
            var _a;
            if (((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.type) === DataSourceTypes.ImageryLayer) {
                if (queryCount) {
                    this.previousRecordLength = 0;
                    this.needToQuery = true;
                }
                if (!this.needToQuery) {
                    this.setState({ loaded: true });
                    return;
                }
            }
            if (this._isMounted && !this.state.staticValues) {
                yield Promise.all([
                    queryCount && dataSourceUtils.queryFeatureCountByField(this.props.field, this.dataSource, this.props.sqlExpression, this.context.scope, this.context.widgetId),
                    dataSourceUtils.queryValueLabelsByFieldAndPageSize(this.props.field, this.dataSource, page * this.state.pageSize, this.props.sqlExpression, this.context.scope, this.context.widgetId)
                ]).then(([count, result]) => {
                    var _a;
                    if (this._isMounted) {
                        if (count === null || result === null) { // skip temporary process
                            return;
                        }
                        // skip for imagery ds to send useless queries since it doesn't support countOnly & distinct
                        if (((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.type) === DataSourceTypes.ImageryLayer) {
                            if (this.previousRecordLength === result.recordLength && result.recordLength) { // selected view: count is 0 when no feature is selected.
                                this.needToQuery = false;
                                this.previousRecordLength = 0;
                                this.setState({ loaded: true });
                                return;
                            }
                            this.previousRecordLength = result.recordLength;
                        }
                        if (!this.state.list && this.props.hideSearchInput) {
                            this.setState({
                                autoFocus: true
                            });
                        }
                        this.setState({
                            count: queryCount ? count : this.state.count,
                            recordCount: result.recordLength,
                            searchPage: queryCount ? 1 : this.state.searchCount,
                            loaded: true,
                            page: page,
                            currentList: result.list,
                            list: result.list
                        }, () => {
                            // Only for the first open the dropdown menu.
                            const autoLoadNextPage = (queryCount || autoTriggeredByFirstPage) && result.recordLength < this.state.count && this.state.count !== 0 && result.list.length < MIN_COUNT_FOR_SCROLLING;
                            if (autoLoadNextPage) {
                                this.loadNextPageData(queryCount || autoTriggeredByFirstPage);
                            }
                        });
                    }
                });
            }
        });
        this.onTogglePopper = (evt) => {
            // const targetClass = evt?.currentTarget?.className
            // if (this.props.isMultiple && targetClass && targetClass.indexOf('select-item') > -1) {
            //   return
            // }
            this.props.toggle && this.props.toggle(!this.state.isOpen);
            if (this._isMounted) {
                if (this.state.isOpen) {
                    this.setState({
                        isOpen: false,
                        isSelectedListShown: false,
                        currentList: this.state.list
                    });
                }
                else {
                    this.setState({
                        isOpen: true
                    });
                }
            }
        };
        this.isItemChecked = (value) => {
            let isActive = false;
            const valueLabels = this.props.selectedValues ? this.props.selectedValues : [];
            if (!this.props.isMultiple && valueLabels.length === 0 && value === EMPTY_OPTION_VALUE) {
                isActive = true;
            }
            else {
                isActive = !!valueLabels.filter(item => item.value === value).length;
            }
            return isActive;
        };
        this.onItemClick = (item, willActive) => {
            var _a;
            let valuePairs = willActive ? [item] : [];
            if (this.props.isMultiple) {
                (_a = this.props.selectedValues) === null || _a === void 0 ? void 0 : _a.forEach(valueLabel => {
                    if (willActive || (!willActive && item.value !== valueLabel.value)) {
                        const _valueLabel = { value: valueLabel.value, label: valueLabel.label };
                        if (valueLabel.render) {
                            _valueLabel.render = valueLabel.render;
                        }
                        valuePairs.push(_valueLabel);
                    }
                });
                valuePairs = this.sortValuePairs(valuePairs);
            }
            else {
                if (!willActive) {
                    return; // can't unSelect item.
                }
                this.setState({ isOpen: false });
                if (valuePairs.length && valuePairs[0].value === EMPTY_OPTION_VALUE) {
                    valuePairs = [];
                }
            }
            valuePairs = valuePairs.length ? valuePairs : null;
            this.props && this.props.onChange(valuePairs);
            // update checkAll states
            if (this.state.showCheckAll) {
                const { checkAllChecked, checkAllIndeterminate } = this.getCheckAllStates(this.state.currentList, valuePairs);
                this.setState({
                    checkAllChecked,
                    checkAllIndeterminate
                });
            }
        };
        this.onScroll = e => {
            const target = e.target;
            const isBottom = target.scrollHeight - target.clientHeight - target.scrollTop <= 10;
            if (this.state.loaded && !this.state.isSelectedListShown && isBottom) {
                this.loadNextPageData();
            }
        };
        this.loadNextPageData = (autoTriggeredByFirstPage = false) => {
            var _a, _b, _c;
            if (!((_a = this.searchRef) === null || _a === void 0 ? void 0 : _a.value)) {
                if (this.state.count > this.state.recordCount) {
                    this.setState({
                        loaded: false
                    }, () => {
                        this.updateList(this.state.page + 1, false, autoTriggeredByFirstPage);
                    });
                }
            }
            else {
                if (this.state.count === this.state.recordCount &&
                    !((_c = (_b = this.props.dataSource) === null || _b === void 0 ? void 0 : _b.getDataViewConfig()) === null || _c === void 0 ? void 0 : _c.maximum) // no maxCount from ds
                ) {
                    return; // no need to query since all features are in local now.
                }
                if (!this.state.searchCount || this.state.searchCount > this.state.searchRecordCount) {
                    this.setState({
                        loaded: false
                    }, () => {
                        this.updateListWithSearchKey(!this.state.searchCount);
                    });
                }
            }
        };
        this.updateListWithSearchKey = (queryCount) => __awaiter(this, void 0, void 0, function* () {
            const sqlExpression = this.getMergedSqlExpressionWithSearchKey();
            const count = queryCount
                ? yield dataSourceUtils.queryFeatureCountByField(this.props.field, this.dataSourceForSearch, sqlExpression, this.context.scope, this.context.widgetId)
                : this.state.searchCount;
            if (this._isMounted && this.state.isOpen) {
                this.setState({
                    searchCount: count,
                    searchPage: queryCount ? 1 : this.state.searchPage
                });
                this.updateSearchList(sqlExpression, Math.ceil((this.state.currentList || []).length / this.state.pageSize + 1)); // result could be null
            }
        });
        this.updateSearchList = (sqlExpression_1, ...args_1) => __awaiter(this, [sqlExpression_1, ...args_1], void 0, function* (sqlExpression, page = this.state.searchPage + 1) {
            var _a, _b;
            const result = yield dataSourceUtils.queryValueLabelsByFieldAndPageSize(this.props.field, this.dataSourceForSearch, page * this.state.pageSize, sqlExpression, this.context.scope, this.context.widgetId);
            if (!this._isMounted || !this.state.isOpen) {
                return;
            }
            // skip for imagery ds to send useless queries since it doesn't support countOnly & distinct
            if (((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.type) === DataSourceTypes.ImageryLayer) {
                if (this.previousRecordLengthForSearch === result.recordLength && result.recordLength) {
                    this.needToQueryForSearch = false;
                    this.previousRecordLengthForSearch = 0;
                    this.setState({ loaded: true });
                    return;
                }
                this.previousRecordLengthForSearch = result.recordLength;
            }
            if (((_b = result === null || result === void 0 ? void 0 : result.list) === null || _b === void 0 ? void 0 : _b.length) < MIN_COUNT_FOR_SCROLLING && (result === null || result === void 0 ? void 0 : result.recordLength) < this.state.searchCount) {
                this.updateSearchList(sqlExpression, page + 1);
            }
            else {
                this.setState({
                    loaded: result !== null, // true only for last searchKey
                    searchRecordCount: result === null || result === void 0 ? void 0 : result.recordLength,
                    searchPage: page,
                    currentList: result === null || result === void 0 ? void 0 : result.list // result could be null
                });
            }
        });
        this.getMergedSqlExpressionWithSearchKey = () => {
            var _a, _b;
            const fieldName = (_a = this.props.field) === null || _a === void 0 ? void 0 : _a.name;
            let searchKeySqlExpression = null;
            let searchKey = this.searchRef.value;
            if (searchKey) {
                let clause;
                if (((_b = this.props.field) === null || _b === void 0 ? void 0 : _b.type) === JimuFieldType.Number) { // CAST(objectid AS CHAR(32)) LIKE '%1%'
                    const keyWhere = `CAST(${fieldName} AS CHAR(${this.numericFieldLength})) LIKE '%${searchKey}%'`;
                    clause = {
                        customSQL: keyWhere,
                        customDisplaySQL: this.i18nMessage('containsForDisplaySQL', { fieldAlias: this.props.field.alias, value: searchKey })
                    };
                }
                else {
                    searchKey = searchKey.replace(/\'/g, "''");
                    clause = dataSourceUtils.createSQLClause(fieldName, ClauseOperator.StringOperatorContains, [{ value: searchKey, label: searchKey }]);
                }
                searchKeySqlExpression = dataSourceUtils.createSQLExpression(ClauseLogic.And, [clause], this.dataSourceForSearch);
            }
            const mergedSqlExpression = dataSourceUtils.getMergedSQLExpressions([this.props.sqlExpression, searchKeySqlExpression], this.dataSourceForSearch, ClauseLogic.And);
            return mergedSqlExpression;
        };
        /**
         * Fired when search text is changed.
         * @param evt
         */
        this.onTextChange = (evt) => {
            var _a, _b;
            const value = evt.target.value;
            if (this.listRef) {
                this.listRef.scrollTop = 0;
            }
            if (this.state.isSelectedListShown) { // filter from selected list
                const currentList = (_a = this.props.selectedValues) === null || _a === void 0 ? void 0 : _a.filter(item => (item.label || '').toUpperCase().includes(value.toString().toUpperCase()));
                this.setState({
                    currentList: currentList
                });
                return;
            }
            this.setState({
                searchCount: 0,
                searchPage: 1
            });
            if (value === '') {
                this.setState({
                    currentList: this.state.list
                });
            }
            else { // query data from local when text is changed.
                // item.label could be null when date feature is { value: 0, label: null}
                const currentList = (_b = this.state.list) === null || _b === void 0 ? void 0 : _b.filter(item => (item.label || '').toUpperCase().indexOf(value.toString().toUpperCase()) >= 0);
                this.setState({
                    currentList: currentList
                }, () => {
                    var _a;
                    // Load more when no scrolling bar, and extra features might exist.
                    if (currentList.length < MIN_COUNT_FOR_SCROLLING) {
                        if (((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.type) === DataSourceTypes.ImageryLayer) {
                            this.previousRecordLengthForSearch = 0;
                            this.needToQueryForSearch = true;
                        }
                        this.loadNextPageData();
                    }
                });
            }
        };
        this.checkAllChange = (evt) => {
            const checked = evt.target.checked;
            this.setState({
                checkAllChecked: checked,
                checkAllIndeterminate: false
            });
            const valuePairs = checked ? this.state.staticValues : null;
            this.props && this.props.onChange(valuePairs);
        };
        this.isDataEmpty = () => {
            var _a;
            return ((_a = this.state.currentList) === null || _a === void 0 ? void 0 : _a.length) === 0;
        };
        this.getAllTag = () => {
            return this.showOutputWarningInBuilder() && this.props.allTag ? this.props.allTag : 'allTag';
        };
        this.getSelectLabel = () => {
            var _a, _b;
            const { placeholder, selectedValues, field } = this.props;
            const noSelectedValues = !selectedValues || selectedValues.length === 0;
            // If don't have selected item and pass in placeholder, show the placeholder.
            if (noSelectedValues && placeholder) {
                return placeholder;
            }
            let label = '';
            if (this.props.isMultiple) {
                const number = selectedValues ? selectedValues.length : 0;
                label = this.i18nMessage('numSelected', { number });
            }
            else {
                const allTag = this.getAllTag();
                const selectedClauseValuePair = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[0];
                if (!this.props.isEmptyOptionHidden && (noSelectedValues || ((selectedClauseValuePair === null || selectedClauseValuePair === void 0 ? void 0 : selectedClauseValuePair.value) === EMPTY_OPTION_VALUE && (selectedClauseValuePair === null || selectedClauseValuePair === void 0 ? void 0 : selectedClauseValuePair.label) === null))) {
                    label = this.i18nMessage(allTag);
                }
                else {
                    const selectedStaticValue = (_a = this.state.staticValues) === null || _a === void 0 ? void 0 : _a.find(c => (c === null || c === void 0 ? void 0 : c.value) === (selectedClauseValuePair === null || selectedClauseValuePair === void 0 ? void 0 : selectedClauseValuePair.value));
                    if (selectedStaticValue === null || selectedStaticValue === void 0 ? void 0 : selectedStaticValue.render) {
                        label = selectedStaticValue.render(selectedStaticValue);
                    }
                    else {
                        label = selectedClauseValuePair === null || selectedClauseValuePair === void 0 ? void 0 : selectedClauseValuePair.label;
                        // Display date field label with timezone setting.
                        if ((field === null || field === void 0 ? void 0 : field.type) === JimuFieldType.Date && selectedClauseValuePair && this.dataSource) {
                            const value = selectedClauseValuePair.value;
                            const valueWithOffset = dataSourceUtils.getDateFieldValue(value, this.dataSource);
                            label = dateUtils.formatDateValueByEsriFormat(valueWithOffset, (_b = field.format) === null || _b === void 0 ? void 0 : _b.dateFormat, this.props.intl); // format might be undefined.
                        }
                    }
                }
            }
            return label;
        };
        this.showSelectedList = (isShown) => {
            var _a;
            const list = isShown ? this.props.selectedValues : this.state.list;
            // should be filtered by current searchKey.
            const searchKey = (_a = this.searchRef) === null || _a === void 0 ? void 0 : _a.value;
            const currentList = searchKey ? list === null || list === void 0 ? void 0 : list.filter(item => item.label.toUpperCase().indexOf(searchKey.toString().toUpperCase()) >= 0) : list;
            this.setState({
                isSelectedListShown: isShown,
                currentList: currentList
            });
            // all local list might not trigger the scrolling bar with searchKey
            if (!isShown && searchKey && (currentList === null || currentList === void 0 ? void 0 : currentList.length) < MIN_COUNT_FOR_SCROLLING) {
                this.setState({
                    searchCount: null,
                    searchRecordCount: null
                }, () => {
                    this.loadNextPageData();
                });
            }
        };
        this.unCheckAll = () => {
            this.showSelectedList(false);
            this.props.onChange(null);
        };
        this.getDropdownMenuStyle = () => {
            return css `
      ${this.buttonRef
                ? `
          min-width: ${polished.rem(this.buttonRef.clientWidth)};
        `
                : ''}
    `;
        };
        this.getOutputWarningContainer = (item) => {
            const isItemChecked = item && this.isItemChecked(item.value);
            return (jsx("div", { className: 'd-flex flex-column ml-2 mr-2 mb-2 output-warning-container' },
                !this.props.isMultiple && item &&
                    jsx(DropdownItem, { className: classNames('select-item', { active: isItemChecked }), onClick: e => { this.onItemClick(item, !isItemChecked); } },
                        jsx("div", { className: classNames({ 'select-item-placeholder': !isItemChecked }) }, isItemChecked && jsx(CheckOutlined, { className: 'mr-2 flex-shrink-0', size: 's' })),
                        jsx("div", { className: classNames('flex-grow-1 text-truncate', { active: isItemChecked }) }, this.i18nMessage(this.getAllTag()))),
                jsx("div", { className: 'd-flex mt-2' },
                    jsx(InfoOutlined, { className: 'mr-2 flex-shrink-0 output-warning-color' }),
                    jsx("span", { className: 'flex-grow-1' }, this.i18nMessage('outputNoValueWarning')))));
        };
        // Overwrite the tab event for dropdown menu.
        this.handelTabEvent = (e) => {
            const previousFocusableNode = this.state.showCheckAll ? this.checkAllRef : !this.props.hideSearchInput && this.searchRef;
            const nextFocusableNode = this.props.isMultiple && !this.props.hideBottomTools && this.showAllRef;
            let nextFocusNode;
            if (e.key === 'Tab' && e.shiftKey) {
                nextFocusNode = previousFocusableNode;
            }
            else if (e.key === 'Tab' && !e.shiftKey) {
                nextFocusNode = nextFocusableNode;
            }
            if (nextFocusNode) {
                e.preventDefault();
                focusElementInKeyboardMode(nextFocusNode, true);
                return true;
            }
            else {
                return false;
            }
        };
        this.showAllKeyDown = e => {
            if (e.key === 'Tab' && e.shiftKey && this.firstMenuItem) {
                e.preventDefault();
                focusElementInKeyboardMode(this.firstMenuItem, true);
            }
            else {
                this.toggleFromFirstNode(e);
            }
        };
        this.getFirstFocusableNode = () => {
            return this.checkAllRef || this.searchRef || this.firstMenuItem || this.showAllRef || this.noDataRef;
        };
        // Toggle to close menu when pressing shift+tab key on first node.
        this.toggleFromFirstNode = e => {
            const firstNode = this.getFirstFocusableNode();
            if (e.key === 'Tab' && e.shiftKey && firstNode === e.target) {
                this.toggleByCustomTabEvent(e);
            }
        };
        // Toggle to close menu from first or last Node.
        this.toggleByCustomTabEvent = e => {
            this.onTogglePopper(e);
            lodash.defer(() => {
                focusElementInKeyboardMode(this.dropdownBtnRef, true);
            });
        };
        // Set noDataRef as a focusable node when no interactive nodes inside.
        this.noInteractiveNodesInside = () => {
            const { hideBottomTools = false, hideSearchInput = false } = this.props;
            return hideBottomTools && hideSearchInput && !this.showCheckAll(this.state.currentList) && (this.state.currentList || []).length === 0;
        };
        this.getFormattedLabel = (label) => {
            var _a;
            let formattedLabelHTML = label;
            if (((_a = this.searchRef) === null || _a === void 0 ? void 0 : _a.value) && label) { // label could be null
                const formattedLabel = label.replace(new RegExp(`(${this.searchRef.value})`, 'gi'), '<strong>$1</strong>');
                formattedLabelHTML = this.sanitizer.sanitize(formattedLabel);
            }
            return formattedLabelHTML;
        };
        this.getLabelWithoutHTML = (label) => {
            if (typeof label === 'string') {
                label = this.sanitizer2.sanitize(label);
            }
            return label;
        };
        this.isRTL = getAppStore().getState().appContext.isRTL;
        const Sanitizer = esri.Sanitizer;
        this.sanitizer = new Sanitizer();
        this.sanitizer2 = new esri.Sanitizer({
            whiteList: {},
            stripIgnoreTag: true
        });
        _AdvancedSelectInner.count++;
        this.localDsRandomId = getLocalDsId();
        this.previousRecordLength = 0;
        this.needToQuery = true;
        this.previousRecordLengthForSearch = 0;
        this.needToQueryForSearch = true;
        const { staticValues, field, dataSource, hideSearchInput, isOpen } = this.props;
        if (!staticValues) {
            this.dsManager = DataSourceManager.getInstance();
            this.numericFieldLength = (field === null || field === void 0 ? void 0 : field.type) === JimuFieldType.Number && numericFieldLength[field === null || field === void 0 ? void 0 : field.esriType];
            this.isHosted = dataSourceUtils.isAGOLHostedService(dataSource.url);
        }
        const realStaticValues = this.getRealStaticValues();
        const showCheckAll = this.showCheckAll(realStaticValues);
        const { checkAllChecked = false, checkAllIndeterminate = false } = showCheckAll ? this.getCheckAllStates(realStaticValues, this.props.selectedValues || []) : {};
        this.state = {
            autoFocus: realStaticValues !== null || !hideSearchInput,
            loaded: !!realStaticValues,
            isSelectedListShown: false,
            pageSize: this.getPageSize(realStaticValues),
            currentList: realStaticValues || [],
            count: (realStaticValues === null || realStaticValues === void 0 ? void 0 : realStaticValues.length) || null,
            recordCount: (realStaticValues === null || realStaticValues === void 0 ? void 0 : realStaticValues.length) || null,
            page: 1,
            list: realStaticValues || null,
            searchCount: null,
            searchRecordCount: null,
            searchPage: 1,
            isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : false,
            staticValues: realStaticValues,
            showCheckAll: showCheckAll,
            checkAllChecked,
            checkAllIndeterminate
        };
        this._isMounted = false;
    }
    componentDidMount() {
        this._isMounted = true;
        this.createDataSources();
        if (!this.state.staticValues) {
            const isOutputInBuilder = this.context.scope !== QueryScope.InRuntimeView && this.props.dataSource.getDataSourceJson().isOutputFromWidget;
            if (!isOutputInBuilder) {
                this.updateList(1, true);
            }
        }
    }
    componentDidUpdate(prevProps, prevStates) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!this._isMounted) {
            return;
        }
        // It needs to focus on first node manually when low network.
        if (this.state.isOpen && !prevStates.autoFocus && this.state.autoFocus) {
            lodash.defer(() => {
                focusElementInKeyboardMode(this.getFirstFocusableNode(), true);
            });
        }
        const isStaticValuesChanged = this.isStaticValuesChanged(this.props.staticValues, prevProps.staticValues);
        const dsChanged = ((_a = this.props.dataSource) === null || _a === void 0 ? void 0 : _a.id) !== ((_b = prevProps.dataSource) === null || _b === void 0 ? void 0 : _b.id);
        const dsInfoChanged = this.isDsInfoChanged(prevProps);
        // Field changed or switching between userInput and unique for domain field.
        if (this.props.field !== prevProps.field ||
            isStaticValuesChanged ||
            dsChanged ||
            dsInfoChanged ||
            this.props.version !== prevProps.version ||
            ((_c = this.props.sqlExpression) === null || _c === void 0 ? void 0 : _c.sql) !== ((_d = prevProps.sqlExpression) === null || _d === void 0 ? void 0 : _d.sql) ||
            this.state.staticValues !== prevStates.staticValues) {
            if (this.props.version !== prevProps.version) {
                this.setState({ isOpen: false });
            }
            else if (this.listRef && this.props.isOpen !== prevProps.isOpen) {
                this.listRef.scrollTop = 0;
            }
            // update local ds when current view, or belongDsView (filters) is changed.
            if (dsChanged || dsInfoChanged) {
                this.createDataSources();
            }
            if (this.props.staticValues) {
                if (this.props.staticValues !== prevProps.staticValues) {
                    const realStaticValues = this.getRealStaticValues();
                    const showCheckAll = this.showCheckAll(realStaticValues);
                    const { checkAllChecked = false, checkAllIndeterminate = false } = showCheckAll ? this.getCheckAllStates(realStaticValues, this.props.selectedValues || []) : {};
                    this.setState({
                        staticValues: realStaticValues,
                        showCheckAll,
                        checkAllChecked,
                        checkAllIndeterminate
                    });
                    return;
                }
                this.setState({
                    loaded: true,
                    pageSize: (_e = this.state.staticValues) === null || _e === void 0 ? void 0 : _e.length,
                    count: (_f = this.state.staticValues) === null || _f === void 0 ? void 0 : _f.length,
                    recordCount: (_g = this.state.staticValues) === null || _g === void 0 ? void 0 : _g.length,
                    page: 1,
                    currentList: this.state.staticValues,
                    list: this.state.staticValues
                });
            }
            else {
                if (this.props.sqlExpression !== prevProps.sqlExpression) {
                    this.setState({
                        loaded: false,
                        page: 1,
                        list: [],
                        currentList: []
                    });
                }
                this.updateList(1, true);
            }
        }
        else if ( // only for storybook
        prevProps.hideCheckAll !== this.props.hideCheckAll ||
            prevProps.hideBottomTools !== this.props.hideBottomTools ||
            prevProps.hideSearchInput !== this.props.hideSearchInput ||
            prevProps.isMultiple !== this.props.isMultiple) {
            const showCheckAll = this.showCheckAll(this.state.staticValues);
            const { checkAllChecked = false, checkAllIndeterminate = false } = showCheckAll ? this.getCheckAllStates(this.state.currentList, this.props.selectedValues || []) : {};
            this.setState({
                showCheckAll,
                checkAllChecked,
                checkAllIndeterminate
            });
        }
    }
    componentWillUnmount() {
        var _a;
        this._isMounted = false;
        (_a = this.listRef) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', this.onScroll);
        this.destroyDataSources();
    }
    render() {
        var _a, _b;
        const _c = this.props, { className, style, title, fluid, autoWidth, size, appendToBody, strategy, zIndex, selectedValues, isEmptyOptionHidden, hideSearchInput, hideBottomTools, buttonProps, menuProps, useKeyUpEvent, isMultiple, customDropdownButtonContent } = _c, otherProps = __rest(_c, ["className", "style", "title", "fluid", "autoWidth", "size", "appendToBody", "strategy", "zIndex", "selectedValues", "isEmptyOptionHidden", "hideSearchInput", "hideBottomTools", "buttonProps", "menuProps", "useKeyUpEvent", "isMultiple", "customDropdownButtonContent"]);
        const isOutputInBuilder = this.showOutputWarningInBuilder();
        let list = this.state.currentList;
        const isNoData = this.isDataEmpty();
        // add -all- option
        const isEmptyOptionShowAndIsSingle = !isEmptyOptionHidden && !isMultiple;
        if (isEmptyOptionShowAndIsSingle) {
            if (isOutputInBuilder) {
                list = [{ value: EMPTY_OPTION_VALUE, label: this.i18nMessage(this.getAllTag()) }].concat(list);
            }
            else {
                if (!((_a = this.searchRef) === null || _a === void 0 ? void 0 : _a.value) && !isNoData) {
                    list = [{ value: EMPTY_OPTION_VALUE, label: this.i18nMessage('allTag') }].concat(list);
                }
            }
        }
        const selectedLabel = this.getSelectLabel();
        const dropdownButtonClass = classNames((_b = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className) !== null && _b !== void 0 ? _b : '', { 'flex-row-reverse': !isMultiple && (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) === 1 && selectedValues[0].value === null });
        return (jsx("div", { ref: node => { this.buttonRef = node; }, style: style, className: classNames('jimu-advanced-select', className || '', fluid ? 'w-100' : '') },
            jsx(Dropdown, { className: 'w-100', size: size, direction: 'down', fluid: fluid, autoWidth: autoWidth, menuItemCheckMode: isMultiple ? 'multiCheck' : 'singleCheck', toggle: this.onTogglePopper, isOpen: this.state.isOpen, useKeyUpEvent: useKeyUpEvent, handelTabEvent: this.handelTabEvent },
                jsx(DropdownButton, Object.assign({ size: size }, buttonProps, { className: dropdownButtonClass, title: title || this.getLabelWithoutHTML(selectedLabel), innerRef: ref => { this.dropdownBtnRef = ref; }, "aria-label": otherProps['aria-label'], "aria-describedby": otherProps['aria-describedby'], "a11y-description": otherProps['a11y-description'] }), customDropdownButtonContent
                    ? customDropdownButtonContent(selectedValues)
                    : typeof selectedLabel === 'string' ? jsx("span", { dangerouslySetInnerHTML: { __html: selectedLabel } }) : selectedLabel),
                jsx(DropdownMenu, Object.assign({ appendToBody: appendToBody, strategy: strategy, zIndex: zIndex, className: 'shadow-3', css: this.getDropdownMenuStyle(), shiftOptions: shiftOptions, autoFocus: this.state.autoFocus, trapFocus: false }, menuProps),
                    jsx("div", { className: classNames('advanced-select-menu', className || '') }, isOutputInBuilder
                        ? jsx(React.Fragment, null, this.getOutputWarningContainer(list === null || list === void 0 ? void 0 : list[0]))
                        : jsx(React.Fragment, null,
                            !hideSearchInput &&
                                jsx("div", { className: 'search-container' },
                                    jsx(TextInput, { prefix: jsx(SearchOutlined, null), allowClear: true, size: 'sm', type: 'text', defaultValue: '', ref: ref => { this.searchRef = ref; }, onKeyDown: this.toggleFromFirstNode, placeholder: this.i18nMessage('SearchLabel'), onChange: this.onTextChange })),
                            jsx("div", { className: 'list-container', onScroll: this.onScroll, ref: ref => { this.listRef = ref; } },
                                this.state.showCheckAll && jsx("div", { className: 'ml-2 mr-2 mb-1' },
                                    jsx(Label, { centric: true, className: 'mb-1' },
                                        jsx(Checkbox, { className: 'mr-2', checked: this.state.checkAllChecked, indeterminate: this.state.checkAllIndeterminate, ref: ref => { this.checkAllRef = ref; }, onChange: this.checkAllChange }),
                                        jsx("span", null, this.i18nMessage('all'))),
                                    jsx("div", { className: 'w-100 split-line' })),
                                isNoData && this.state.loaded && jsx("div", { className: 'no-data-label', tabIndex: this.noInteractiveNodesInside() ? 0 : 1, ref: ref => { this.noDataRef = ref; } }, this.i18nMessage('noData')),
                                list && list.map((item, index) => {
                                    if (item && item.value !== null) {
                                        const isItemChecked = this.isItemChecked(item.value);
                                        const label = item.label || (item.value === EMPTY_OPTION_VALUE ? this.i18nMessage(this.getAllTag()) : item.value);
                                        const labelForNoRender = !item.render && this.getFormattedLabel(label);
                                        return (jsx(DropdownItem, { ref: ref => { if (index === 0) {
                                                this.firstMenuItem = ref;
                                            } }, key: index, className: classNames('select-item', { 'multiple-item': isMultiple }, { active: isItemChecked }), toggle: !isMultiple, onClick: e => { this.onItemClick(item, !isItemChecked); }, disabled: item.disabled, active: isItemChecked },
                                            isMultiple
                                                ? jsx(Checkbox, { checked: isItemChecked, className: 'mr-2' })
                                                : jsx("div", { className: classNames({ 'select-item-placeholder': !isItemChecked }) }, isItemChecked && jsx(CheckOutlined, { className: 'jimu-icon-auto-color mr-2 flex-shrink-0', size: 's' })),
                                            item.render
                                                ? item.render(item)
                                                : jsx("div", { className: classNames('flex-grow-1 text-truncate', { active: isItemChecked }), title: this.getLabelWithoutHTML(labelForNoRender), dangerouslySetInnerHTML: { __html: labelForNoRender } })));
                                    }
                                    else {
                                        return null;
                                    }
                                }),
                                !this.state.loaded && jsx("div", { className: 'loading-container' },
                                    jsx(Loading, { type: LoadingType.Donut, width: 16, height: 16 }))),
                            isMultiple && !hideBottomTools && jsx("div", { className: 'multiple-select-tool split-line' },
                                jsx("div", { className: 'd-flex flex-grow-1' },
                                    jsx(Button, { icon: true, size: 'sm', type: this.state.isSelectedListShown ? 'tertiary' : 'primary', title: this.i18nMessage('showAll'), ref: ref => { this.showAllRef = ref; }, onClick: e => { this.showSelectedList(false); }, onKeyDown: this.showAllKeyDown },
                                        jsx(MenuOutlined, null)),
                                    jsx(Button, { icon: true, type: this.state.isSelectedListShown ? 'primary' : 'tertiary', size: 'sm', title: this.i18nMessage('showSelection'), onClick: e => { this.showSelectedList(true); }, className: 'ml-1' }, this.isRTL ? jsx(ShowSelectionRtlOutlined, null) : jsx(ShowSelectionOutlined, null))),
                                jsx(Button, { icon: true, type: 'tertiary', size: 'sm', title: this.i18nMessage('clearSelection'), onClick: e => { this.unCheckAll(); } },
                                    jsx(TrashCheckOutlined, null))),
                            jsx(Button, { className: 'sr-only last-virtual-node', onFocus: this.toggleByCustomTabEvent })))))));
    }
}
_AdvancedSelectInner.contextType = QueryScopeContext;
_AdvancedSelectInner.count = -1;
_AdvancedSelectInner.a11yCount = 0;
const getLocalDsId = () => {
    return `${LOCAL_DS_PREFIX}-${_AdvancedSelectInner.count}`;
};
const mapStateToProps = (state, ownProps) => {
    const s = window.jimuConfig.isBuilder ? state.appStateInBuilder : state;
    if (!s || !ownProps.dataSource) {
        return {
            dataSourceInfo: null,
            dataSourceBelongInfo: null
        };
    }
    return {
        dataSourceInfo: s.dataSourcesInfo[ownProps.dataSource.id] || null,
        dataSourceBelongInfo: ownProps.dataSource.isDataView ? s.dataSourcesInfo[ownProps.dataSource.belongToDataSource.id] : null
    };
};
/**
 * The `AdvancedSelect` component is used to provide the ability to choose an option from a list.
 *
 * Please use this component in case of the following needs:
 *
 * - Search function.
 * - Selection tools for multiple option.
 * - Display dynamic attribute from a field of dataSource with pagination.
 *
 * ```ts
 * import { AdvancedSelect } from 'jimu-ui'
 * ```
 */
export const _AdvancedSelect = ReactRedux.connect(mapStateToProps)(_AdvancedSelectInner);
export const AdvancedSelect = withStyles(injectIntl(_AdvancedSelect), 'AdvancedSelect');
